module.exports = __webpack_public_path__ + "img/arr_down_white.72493a67.svg";